/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=711bc4d3&scoped=true&"
import script from "./Detail.vue?vue&type=script&setup=true&lang=js&"
export * from "./Detail.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=711bc4d3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711bc4d3",
  null
  
)

export default component.exports